import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "./useAuth";
import { canAccess, type ModuleKey } from "./rbac";

// Route-level role gate. Redirects to dashboard if the admin's role can't see
// this module (cosmetic — see rbac.ts; not a security boundary).
export function RoleGate({
  module,
  children,
}: {
  module: ModuleKey;
  children: ReactNode;
}) {
  const { admin } = useAuth();
  if (!canAccess(admin?.role, module)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
